package com.siriusxm.pia.rest.unifiedaggregator

import unifiedcontent.aggregator.Aggregator
import contentingestion.unifiedmodel.EntityType as UEntityType
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.jsonObject


// --- Backfill Mappers ---

// --- Feature Flags ---
// --- Relationships ---

fun unifiedcontent.aggregator.RelationshipSchema.toUi(): com.siriusxm.pia.rest.unifiedaggregator.RelationshipSchema {
    return com.siriusxm.pia.rest.unifiedaggregator.RelationshipSchema(
        id = this.id,
        name = this.name ?: "",
        description = this.description ?: "",
        editable = this.editable ?: false,
        subject = this.subject?.toUi() ?: error("Relationship subject cannot be null"),
        `object` = this.`object`?.toUi() ?: error("Relationship object cannot be null")
    )
}

fun unifiedcontent.aggregator.RelationshipActor.toUi(): com.siriusxm.pia.rest.unifiedaggregator.RelationshipActor {
    return com.siriusxm.pia.rest.unifiedaggregator.RelationshipActor(
        type = this.type,
        fieldLinkToSibling = this.fieldLinkToSibling,
        sortKey = this.sortKey,
        aggregationField = null
    )
}

fun unifiedcontent.aggregator.EntityRelationship.toUi(): com.siriusxm.pia.rest.unifiedaggregator.EntityRelationship {
    return com.siriusxm.pia.rest.unifiedaggregator.EntityRelationship(
        schemaId = this.schemaId,
        subject = this.subject.takeIf { it is JsonObject } as? JsonObject ?: buildJsonObject {},
        `object` = this.`object`.takeIf { it is JsonObject } as? JsonObject ?: buildJsonObject {}
    )
}

fun JsonElement.jsonObjectOrNull(): JsonObject? = this as? JsonObject

// --- IncomingEntity Mappers ---

/**
 * Fetches and converts the SDK IncomingEntityResult to the UI IncomingEntityResult type.
 * This extension avoids direct dependency on SDK-internal partial event types.
 */
suspend fun Aggregator.getIncomingEntityUi(
    id: String,
    type: String,
    version: String,
): IncomingEntityResult {
    val result = getIncomingEntity(id, UEntityType.fromName(type), version)
    return IncomingEntityResult(
        entity = IncomingEvent(
            ts = result.entity.ts,
            auditContext = result.entity.auditContext,
            source = result.entity.source,
            data = result.entity.data.jsonObject,
        ),
        partials = result.partials?.map {
            IncomingEvent(
                ts = it.ts,
                source = it.source,
                data = it.data.jsonObject,
                partialId = it.partialId,
                operations = it.operations,
                auditContext = it.auditContext,
            )
        },
        scheduled = result.scheduled,
    )
}

// --- Relationship Mappers ---

fun IncomingRelationshipUpdate.toSdk(): unifiedcontent.aggregator.IncomingRelationshipUpdate {
    return unifiedcontent.aggregator.IncomingRelationshipUpdate(subject, `object`, data)
}

// --- EntityListResponse Mapper ---

fun unifiedcontent.aggregator.EntityListResponse.toUi(): EntityListResponse {
    return EntityListResponse(
        entities = entities.mapNotNull { it as? JsonObject },
        paginationToken = paginationToken,
    )
}
